import { combineReducers } from 'redux';
import authReducer from './features/auth/authSlice';
import masterDataReducer from './features/masterData/masterDataSlice';

export default combineReducers({
  auth: authReducer,
  masterData: masterDataReducer
});
